import { Helmet } from "react-helmet-async";
import AgentsProtectedRoute from "./AgentProtectedRoute";
import ManagerRoute from "./ManagerRoute";
import faviconAdmin from "../../favicon_green.ico";

export const ProtectedPage = ({ title, children }) => (
  <AgentsProtectedRoute>
    <Helmet>
      <meta charSet="utf-8" />
      <link rel="icon" href={faviconAdmin} />
      <title>{title}</title>
    </Helmet>
    {children}
  </AgentsProtectedRoute>
);

export const ManagerPage = ({ title, children }) => (
  <ManagerRoute>
    <Helmet>
      <meta charSet="utf-8" />
      <link rel="icon" href={faviconAdmin} />
      <title>{title}</title>
    </Helmet>
    {children}
  </ManagerRoute>
);
